import {
	Edit,
	SimpleForm,
	TextInput,
	useNotify,
	useRedirect,
	useRefresh,
	NumberInput,
	minValue,
	SelectInput,
	FormDataConsumer,
	useUpdate,
	useGetOne,
	TextField,
	BooleanField,
	FunctionField,
} from "react-admin";
import { validateMemberData } from "./memberValidate";
import { CustomTransferList } from "../../customComponents/CustomTransferList";
import { genders, arabic } from "../../utils/constants";
import { setIndexesForData } from "../../utils/customFunctions";
import { CustomToolbar } from "../../customComponents/CustomToolbar";

export const MemberEdit = (props) => {
	const notify = useNotify();
	const refresh = useRefresh();
	const redirect = useRedirect();
	const { data: { email = null, phoneNumber = null } = {}, loading } =
		useGetOne("members", props.id) || {};
	const [update] = useUpdate("members", props.id);
	const onSuccess = () => {
		notify("members.edit.success", "info");
		redirect("/members");
		refresh();
	};

	const onFailure = (error) => {
		notify(error.message, "warning");
	};

	return (
		<>
			{loading ? (
				<center>
					<h1>Loading...</h1>
				</center>
			) : (
				<Edit
					title={"Edit Member"}
					{...props}
					mutationMode="pessimistic"
					toolbar={<CustomToolbar />}
				>
					<SimpleForm
						validate={validateMemberData}
						toolbar={<CustomToolbar />}
						save={(data) => {
							const indexedData = setIndexesForData(data, [
								"objectives",
							]);
							if (!indexedData?.objectives?.length) {
								notify(
									"You must add one objective at least!",
									"warning"
								);
								return;
							}
							indexedData.objectives = indexedData.objectives.map(
								({ id }) => id
							);
							update(
								{
									payload: {
										data: {
											...indexedData,
											onboardingData: {
												gender: indexedData.gender,
												objectives:
													indexedData.objectives,
												language: arabic,
											},
										},
									},
								},
								{
									onSuccess,
									onFailure,
								}
							);
						}}
					>
						{email && <TextField source="email" />}
						<TextField source="country" label="Country" emptyText="Not captured" />
						{phoneNumber && <TextField source="phoneNumber" />}
						<TextField source="method" />
						<SelectInput 
							source="subscriptionType" 
							label="Subscription Type"
							choices={[
								{ id: "FREEMIUM", name: "Freemium" },
        						{ id: "FREEMIUM_PASS", name: "Freemium Pass" },
        						{ id: "SUBSCRIBED", name: "Premium" }
							]}
						/>
						<TextField source="revokeDate" />
						<TextField source="validUntil" />
						<TextInput source="firstName" />
						<FormDataConsumer>
							{({ formData, ...rest }) => 
								formData.subscriptionType !== "FREEMIUM" && (
									<NumberInput
										source="days"
										label="Subscription Days"
										validate={[minValue(1)]}
										helperText="Days of access remaining from today. Change it to reset the expiry to today plus this many days."
										{...rest}
									/>
								)
							}
						</FormDataConsumer>
						<SelectInput
							source="gender"
							choices={genders.slice(0, 2)}
							defaultValue="FEMALE"
							optionText={({ name }) => name}
							optionValue="id"
						/>
						<FunctionField
							label="Consented to the privacy policy"
							render={(record) => {
								return record && record.consented ? record.consented : "X";
							}}
						/>
						<CustomTransferList
							source="objectives"
							referenceSource="objectives"
							referenceResource="objectives"
							referenceField="titles"
							isReferenceTranslatable={true}
							customFilter="(({comingSoon})=>!comingSoon)"
						/>
					</SimpleForm>
				</Edit>
			)}
		</>
	);
};
